import * as Croppie from '../packs/_add/croppie';
import { popupError, popupSuccess } from '../packs/company/popup';

$(window).on('turbolinks:load', function() {
  /**
   * 画像ファイルを切り抜く機能があるフィールド
   * */
  for (const cropField of document.getElementsByClassName('js-imageCropField')) {
    let _croppie;
    const input = cropField.getElementsByClassName('js-imageCropField-input')[0];
    const inputChanged = cropField.getElementsByClassName('js-imageCropField-inputChanged')[0];
    const currentImg = cropField.getElementsByClassName('js-imageCropField-currentImg')[0];
    const deleteButton = cropField.getElementsByClassName('js-imageCropField-deleteButton')[0];
    const modal = document.querySelector(`.js-imageCropField-modal[data-field-name="${cropField.dataset.fieldName}"]`);
    const modalView = modal.getElementsByClassName('js-imageCropField-modalView')[0];
    const execButton = modal.getElementsByClassName('js-imageCropField-execButton')[0];
    const croppieMountTarget = modal.getElementsByClassName('js-imageCropField-mount')[0];

    // init
    input.value = null;
    inputChanged.value = false;

    const magnification = parseInt(cropField.dataset.magnification, 10);
    let [vW, vH] = cropField.dataset.viewport.split('x').map((n) => parseInt(n, 10));
    let bW = vW + 50;
    let bH = vH + 50;

    const attached = input.dataset.attached === 'true';
    const setSelected = (bool) => {
      if (bool) {
        cropField.classList.add('selected');
      } else {
        cropField.classList.remove('selected');
      }
    };
    const setChanged = (bool) => inputChanged.value = bool;
    const clearInput = () => input.value = null;

    // ファイルを選択
    input.addEventListener('change', (e) => {
      $(modal).fadeIn(200);
      // モーダルからはみ出す場合はサイズを調整する
      if ((modalView.getBoundingClientRect().width - 30) - bW < 0) {
        const adjustRatio = (modalView.getBoundingClientRect().width - 30) / bW;
        vW = vW * adjustRatio;
        vH = vH * adjustRatio;
        bW = bW * adjustRatio;
        bH = bH * adjustRatio;
      }
      _croppie = new Croppie(croppieMountTarget, {
        viewport: { width: vW, height: vH },
        boundary: { width: bW, height: bH },
      });
      _croppie.bind({ url: URL.createObjectURL(input.files[0]) });
    });

    // クロップをキャンセル
    modal.addEventListener('click', (e) => {
      const cancel = e.target.closest('.js-imageCropField-cancelButton');
      if (cancel) {
        setTimeout(() => _croppie.destroy(), 200);
        clearInput();
        setSelected(false);
        if (attached) {
          setChanged(true);
        } else {
          setChanged(false);
        }
      };
    });

    // クロップを実行
    execButton.addEventListener('click', () => {
      _croppie.result({
        type: 'blob',
        size: { width: vW * magnification, height: vH * magnification },
        format: 'webp',
      }).then((blob) => {
        // 切り取り結果のblobをfile inputに設定し直す
        const croppedImage = new File([blob], `${Date.now()}.webp`, { type: blob.type });
        const newFileList = new DataTransfer();
        newFileList.items.add(croppedImage);
        input.files = newFileList.files;

        currentImg.src = URL.createObjectURL(croppedImage);
        $(modal).fadeOut(200);
        setTimeout(() => _croppie.destroy(), 200);
        setSelected(true);
        setChanged(true);
      });
    });

    // 削除
    deleteButton.addEventListener('click', () => {
      clearInput();
      setSelected(false);
      setChanged(attached);
    });
  }

  /**
   * labelタグの代わりにbuttonを使用する場合
  */
  for (const labelButton of document.getElementsByClassName('js-labelButton')) {
    labelButton.addEventListener('click', () => {
      const input = document.getElementById(labelButton.dataset.for);
      if (!input) return;
      input.click();
    });
  }

  document.querySelectorAll('.js-form-statusSelect')?.forEach((statusSelect) => {
    const select = statusSelect.querySelector('select');
    const items = statusSelect.querySelector('.items');
    const itemsArray = Array.from(items.children);
    const current = statusSelect.querySelector('.current');
    while (current.firstChild) { current.removeChild(current.firstChild) }

    current.appendChild(itemsArray[select.selectedIndex].cloneNode(true));

    statusSelect.addEventListener('click', (e) => {
      if (!e.target.classList.contains('item')) return;
      if (statusSelect.classList.contains('isDisabled')) return;
      if (e.target.closest('.current')) { items.classList.toggle('hide') }
      if (e.target.closest('.items')) {
        items.classList.add('hide');
        const item = e.target.closest('.item');
        const selectedIndex = itemsArray.indexOf(item);
        select.selectedIndex = selectedIndex;

        while (current.firstChild) { current.removeChild(current.firstChild) }
        current.appendChild(itemsArray[selectedIndex].cloneNode(true));

        select.dispatchEvent(new Event('change'));
      }
    });
  });

  // 対応状況や社員のラベルの変更
  if (document.getElementsByClassName('js-form-statusSelect-updateAjax')) {
    for (const statusSelectUpdateAjax of document.getElementsByClassName('js-form-statusSelect-updateAjax')) {
      statusSelectUpdateAjax.querySelector('select')?.addEventListener('change', async (e) => {
        const form = e.currentTarget.closest('form');
        const formData = new FormData(form);
        const sendJson = Object.fromEntries(formData.entries());

        const res = await fetch(form.action, {
          method: 'PUT',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(sendJson),
        });

        const resJson = await res.json();
        if (res.ok) {
          // 対応状況を変更したときにメッセージを送れるようにする
          if (statusSelectUpdateAjax.classList.contains('js-form-statusSelect-afterSendMessgae')) {
            // 対応状況が「未対応」「既存社員」以外のときのみメッセージを送信できる
            if (sendJson.proccess !== 'unsupported' && sendJson.proccess !== 'existing_staff') {
              const _VueRecruitCreateMessageUi = window.VueRecruitCreateMessageUi.$children[0];
              const _VueApplicantEmailTemplate = window.VueApplicantEmailTemplate.$children[0];

              _VueRecruitCreateMessageUi.formAction = resJson.form_action;
              _VueRecruitCreateMessageUi.recruitId = resJson.recruit_id;
              _VueRecruitCreateMessageUi.userId = resJson.assessment_id;
              _VueRecruitCreateMessageUi.subject = resJson.subject;
              _VueRecruitCreateMessageUi.content = resJson.content;
              _VueApplicantEmailTemplate.$set(
                _VueApplicantEmailTemplate.modalType,
                'recruitId',
                resJson.recruit_id
              );
              _VueApplicantEmailTemplate.$set(
                _VueApplicantEmailTemplate.modalType,
                'userId',
                resJson.assessment_id
              );

              const focusUI = _VueRecruitCreateMessageUi.$el.querySelector('.js-messageFocusUi');
              const obs = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    focusUI.classList.add('is-active');
                    focusUI.querySelector('input').focus();
                    observer.disconnect();
                  }
                });
              }, { threshold: 0.9 });
              obs.observe(focusUI);
              focusUI.scrollIntoView({ behavior: 'smooth', block: 'end' });

              switch (resJson.user_type) {
                case 'person': // CIYユーザーの場合
                  _VueRecruitCreateMessageUi.userType = 'person';
                  _VueApplicantEmailTemplate.$set(
                    _VueApplicantEmailTemplate.modalType,
                    'userType',
                    'person'
                  );

                  const sendMailModal = document.querySelector('[data-modal="applicant-proccess-email"]');
                  $(sendMailModal).show();
                  break;
                case 'applicant': // CIYユーザーではない場合
                  // emailを持っている場合
                  if (resJson.has_email) {
                    _VueRecruitCreateMessageUi.userType = 'applicant';
                    _VueApplicantEmailTemplate.$set(
                      _VueApplicantEmailTemplate.modalType,
                      'userType',
                      'applicant'
                    );

                    const sendMailModal = document.querySelector('[data-modal="applicant-proccess-email"]');
                    $(sendMailModal).show();
                  }
                  break;
              }
            }
          }
          popupSuccess(resJson.message);
        } else {
          popupError(resJson.message);
        }
      });
    }
  }

  document.querySelectorAll('.js-employeeAssessmentModal-select')?.forEach((select) => {
    const changeItems = () => {
      const items = document.querySelectorAll('.js-employeeAssessmentModal-item');
      items?.forEach((item) => {
        if (item.dataset.recruitId === select.value) {
          item.classList.add('isActive');
        } else {
          item.classList.remove('isActive');
        }
      });
    }
    changeItems();

    select.addEventListener('change', () => {
      if (!!select.value.trim()) {
        changeItems();
      }
    });
  });

  // 診断者名編集モーダル: 空入力を弾く(送信もモーダルクローズもさせない)
  // js-ajaxForm の submit リスナーより前に登録し、空なら stopImmediatePropagation で送信を抑止する
  document.querySelectorAll('.js-required-name-form').forEach((form) => {
    const isBlank = () => {
      const input = form.querySelector('input[name="name"]');
      return !input || input.value.trim() === '';
    };
    // 通常送信(クリック/Enter/requestSubmit)を止める
    form.addEventListener('submit', (e) => {
      if (isBlank()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        popupError('診断者名を入力してください');
      }
    });
    // 送信ボタンのクリックでモーダルを閉じさせない(document委譲の modal-close へ到達させない)
    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        if (isBlank()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          popupError('診断者名を入力してください');
        }
      });
    }
  });

  document.querySelectorAll('.js-ajaxForm').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      (async () => {
        const response = await fetch(form.action, {
          headers: {
            Accept: 'application/json',
          },
          method: form._method ? form._method.value.toUpperCase() : 'POST',
          body: new FormData(form),
        });
        const data = await response.json();

        if (response.ok) {
          popupSuccess(data.popup_success);
        } else {
          popupError(data.popup_error);
        }

        if (data.modal_close) {
          document
            .querySelectorAll('.modal-wrap[data-modal]')
            .forEach((modal) => (modal.style.display = 'none'));
        }
      })();
    });
  });

  document.querySelectorAll('.js-textSync-input').forEach((input) => {
    const syncId = input.dataset.syncid;
    const targets = document.querySelectorAll(
      `.js-textSync-target[data-syncid="${syncId}"]`
    );
    targets.forEach((target) => {
      input.addEventListener('input', (e) => {
        target.textContent =
          e.target.value.length === 0
            ? target.dataset.syncdefault
            : e.target.value;
      });
    });
  });

  for (const checkAllParent of document.getElementsByClassName('js-checkAll-parent')) {
    const childrenGroup = document.querySelector(`.js-checkAll-children[data-key="${checkAllParent.dataset.key}"]`);
    const children = childrenGroup.querySelectorAll('input[type="checkbox"]');
    checkAllParent.addEventListener('change', (e) => {
      for (const child of children) child.checked = e.currentTarget.checked;
    });

    childrenGroup.addEventListener('change', (e) => {
      checkAllParent.checked = children.length === Array.from(children).filter((child) => child.checked).length;
    });
  }

  // ユーザーのお気に入りを切り替えるチェックボックス
  for (const checkBox of document.getElementsByClassName('js-userFavToggleCheckBox')) {
    checkBox.addEventListener('change', async (e) => {
      const user_id = checkBox.dataset.userId;
      const recruit_id = checkBox.dataset.recruitId;

      const res = await fetch('/company/ajax/company/favorite', {
        method: checkBox.checked ? 'POST' : 'DELETE',
        credentials: 'same-origin',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user_id, recruit_id }),
      });
      // checkBox.checked = res.ok;
    });
  }

   /* チェックを入れたら、次へのボタンが押せるようにする。
  -------------------------------*/
  const interactiveSubmit = document.querySelector('.js-interactiveBtn');
  if (interactiveSubmit) {
    const checkboxes = document.querySelectorAll('.js-interactiveFlag[type="checkbox"]');

    const updateButtonState = () => {
      const allChecked = Array.from(checkboxes).every(cb => cb.checked);
      interactiveSubmit.classList.toggle('is-active', allChecked);
    };

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', updateButtonState);
    });
  }

  // メール送信UI関連
  if (document.getElementsByClassName('js-companyMessageUi').length > 0) {
    const fileDigest = async (arrayBuffer) => {
      const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
      return hashHex;
    };

    const formatFileSize = (bytes) => {
      if (bytes < 1024) {
        return  `${bytes}B`;
      } else if (bytes < 1024 * 1024) {
        return `${(bytes / 1024).toFixed(2)}KB`;
      } else if (bytes < 1024 * 1024 * 1024) {
        return `${(bytes / 1024 / 1024).toFixed(2)}MB`;
      } else {
        return `${(bytes / 1024 / 1024 / 1024).toFixed(2)}GB`;
      }
    }

    const validate = (form) => {
      const errors = new Set();
      if (form.subject.value.trim() === '') {
        errors.add('件名をご入力ください。');
      }
      if (form.content.value.trim() === '') {
        errors.add('本文をご入力ください。');
      }
      if (form.content.value.includes('●')) {
        errors.add('本文内に、定型文のサンプル文字「●」が含まれています。');
      }
      const files = form['attach_files[]']?.files;
      if (files.length > 0) {
        const maxSize = 1 * 1024 * 1024;
        for (const file of files) {
          if (file.size > maxSize) {
            errors.add('添付ファイルのサイズは5MB以下にしてください。');
            break;
          }
        }
      }
      if (files.length > 5) {
        errors.add('添付ファイルは一度に5ファイルまで送信可能です。');
      }
      return errors;
    };

    for (const messageForm of document.getElementsByClassName('js-companyMessageUi-form')) {
      const modal = messageForm.closest('[data-modal]');
      const errorMessages = modal.querySelector('.js-companyMessageUi-errorMessages');
      const template = errorMessages.querySelector('template');
      let submitted = false;

      const beforeSubmit = modal.querySelector('.js-scoutModal-beforeSubmit');
      const afterSubmit = modal.querySelector('.js-scoutModal-afterSubmit');
      $(beforeSubmit).show();
      $(afterSubmit).hide();

      if (messageForm.dataset.type === 'scout') {
        afterSubmit.addEventListener('click', (e) => {
          if (e.target.closest('.modal-close')) {
            $(beforeSubmit).show();
            $(afterSubmit).hide();
          }
        });
      }

      messageForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (submitted) return;
        Array.from(errorMessages.children).forEach((child) => {
          if (child !== template) errorMessages.removeChild(child);
        });

        const errors = validate(messageForm);
        if (errors.size === 0) {
          e.submitter.classList.add('isSending');
          if (messageForm.classList.contains('isAjax')) {
            submitted = true;
            const response = await fetch(messageForm.action, {
              method: messageForm.method,
              headers: {
                'X-Requested-With': 'fetch'
              },
              body: new FormData(messageForm),
            });
            const resJson = await response.json();
            if (resJson.status === 'success') {
              // user_codeを取得し、スカウトを送った人のDOMをいったん削除する
              
              const userCodes = Array.from(messageForm.querySelectorAll('input[name="user_code[]"]'))
              .map(input => input.value);
              userCodes.forEach((code) => {
                document.querySelectorAll('.js-removeAfterScoutSend').forEach((el) => {
                  if (el.dataset.usercode === code) {
                    el.remove();
                  }
                });
              });
              $(beforeSubmit).hide();
              $(afterSubmit).show();
              e.submitter.classList.remove('isSending');
            }
            submitted = false;
          } else {
            messageForm.submit();
          }
        } else {
          errors.forEach((message) => {
            const clone = template.content.cloneNode(true);
            clone.querySelector('p').textContent = message;
            errorMessages.appendChild(clone);
          });
        }
      });

      // ファイル添付ボタンがある場合
      if (document.querySelector('.p-companyMessageUi-buttons-item.attachFile')) {
        const updateFilelistUi = (attachedFiles, attachedFilesTarget) => {
          const template = attachedFilesTarget.querySelector('template');
          Array.from(attachedFilesTarget.children).forEach((child) => {
            if (child !== template) attachedFilesTarget.removeChild(child);
          });
          Object.entries(attachedFiles).forEach(([digest, file]) => {
            const clone = template.content.cloneNode(true);
            clone.querySelector('[data-digest]').dataset.digest = digest;
            clone.querySelector('[data-filename]').textContent = file.name;
            clone.querySelector('[data-filesize]').textContent = formatFileSize(file.size);
            attachedFilesTarget.appendChild(clone);
          });
        };

        const updateFileInput = (attachedFiles, fileInput) => {
          const dataTransfer = new DataTransfer();
          Object.values(attachedFiles).forEach((file) => dataTransfer.items.add(file));
          fileInput.files = dataTransfer.files;
        };

        const attachedFiles = {};
        const fileInput = messageForm.querySelector('input[type="file"][name="attach_files[]"]');
        const attachedFilesTarget = messageForm.querySelector('.js-companyMessageUi-attachedFiles');

        fileInput.addEventListener('change', async (e) => {
          const files = await Promise.all(Array.from(fileInput.files).map((file) => {
            return new Promise((resolve) => {
              file.arrayBuffer().then((arrayBuffer) => {
                resolve({ file, arrayBuffer });
              })
            });
          }));
          const digestList = await Promise.all(files.map((file) => {
            return new Promise((resolve) => {
              fileDigest(file.arrayBuffer).then((digest) => {
                resolve({ [digest]: file.file });
              });
            });
          }));
          Object.assign(attachedFiles, ...digestList);
          updateFilelistUi(attachedFiles, attachedFilesTarget);
          updateFileInput(attachedFiles, fileInput);
        });

        attachedFilesTarget.addEventListener('click', (e) => {
          const detachButton = e.target.closest('.js-companyMessageUi-detachButton');
          if (detachButton) {
            const deleteItem = detachButton.closest('[data-digest]');
            const detachDigest = deleteItem?.dataset.digest;

            const duration = 170;
            delete attachedFiles[detachDigest];
            deleteItem.animate({ opacity: [1, 0], easing: 'ease-out' }, duration);
            updateFileInput(attachedFiles, fileInput);
            setTimeout(() => updateFilelistUi(attachedFiles, attachedFilesTarget), duration);
          }
        });
      }
    }
  }
})

$(window).on('turbolinks:load', function() {
  // 1on1面談ノート
  // 初回の保存では新規レコードを作成（create）、以降ページをリロードせずに保存した場合は
  // 同じレコードを更新（update）する。リロードすると createdId は初期化され、再び create になる。
  document.querySelectorAll('.js-oneOnOneForm').forEach((form) => {
    // turbolinks:load が複数回発火しても submit ハンドラを二重登録しないようにする。
    // 二重登録されると createdId=null の新しいクロージャが毎回 create してしまい、
    // 更新ではなく新規レコードが追加され続ける。
    // （data属性だとturbolinksのページキャッシュに焼き込まれるためJSプロパティで持つ）
    if (form._oneOnOneBound) return;
    form._oneOnOneBound = true;

    let createdId = null;
    let isSubmitting = false;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (isSubmitting) return;
      isSubmitting = true;

      const isUpdate = createdId !== null;
      const formData = new FormData(form);
      if (isUpdate) formData.append('id', createdId);

      try {
        const response = await fetch(form.action, {
          method: isUpdate ? 'PATCH' : 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const data = await response.json();

        if (response.ok) {
          // 作成したレコードのidを保持し、次回以降の保存を更新に切り替える
          if (!isUpdate) createdId = data.id;
          popupSuccess(data.popup_success);
        } else {
          popupError(data.popup_error || data.error);
        }
      } finally {
        isSubmitting = false;
      }
    });
  });

  // これまでの1on1記録（履歴モーダル内）の編集・保存
  // 既存レコードなので常に update（id は hidden フィールドで送る）
  document.querySelectorAll('.js-oneOnOneEditForm').forEach((form) => {
    if (form._oneOnOneBound) return;
    form._oneOnOneBound = true;

    let isSubmitting = false;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (isSubmitting) return;
      isSubmitting = true;

      try {
        const response = await fetch(form.action, {
          method: 'PATCH',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const data = await response.json();

        if (response.ok) {
          popupSuccess(data.popup_success);
        } else {
          popupError(data.popup_error || data.error);
        }
      } finally {
        isSubmitting = false;
      }
    });
  });

  // これまでの1on1記録の削除
  document.querySelectorAll('.js-oneOnOneDeleteButton').forEach((button) => {
    if (button._oneOnOneBound) return;
    button._oneOnOneBound = true;

    button.addEventListener('click', async () => {
      if (!window.confirm('この1on1記録を削除しますか？')) return;

      const form = button.closest('form');
      const response = await fetch(form.action, {
        method: 'DELETE',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await response.json();

      if (response.ok) {
        form.remove();
        popupSuccess(data.popup_success);
      } else {
        popupError(data.popup_error || data.error);
      }
    });
  });
})

$(window).on('turbolinks:load', function() {
  // 社員メモ（社員詳細ページ）の保存・更新
  // 既存の Directly::Assessment#person_note を更新するだけなので常に PUT
  document.querySelectorAll('.js-personNoteForm').forEach((form) => {
    if (form._personNoteBound) return;
    form._personNoteBound = true;

    let isSubmitting = false;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (isSubmitting) return;
      isSubmitting = true;

      try {
        const response = await fetch(form.action, {
          method: 'PUT',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const data = await response.json();

        if (response.ok) {
          popupSuccess(data.popup_success);
        } else {
          popupError(data.popup_error || data.error);
        }
      } finally {
        isSubmitting = false;
      }
    });
  });
})
